'use client'

import { Link as MuiLink, Typography } from '@mui/material'
import { useCallback, useMemo, useRef } from 'react'
import classNames from 'classnames'
import NextLink from 'next/link'
import urlJoin from 'url-join'
import { useGlobalState } from '../../context/globalStateProvider'
//import { useTracker } from '@biolumina/ui/hooks/gtm.hooks'

export const Link = ({
  active,
  children,
  className,
  href = "",
  OneTrust,
  external,
  sx,
  variant = "link",
  target,
  prompt = false,
  linkComponent = MuiLink,
  component = "span",
  ...props
}) => {
  const { setExternalLink, setExternalModalId } = useGlobalState();
  //const { trackClick } = useTracker()
  const linkRef = useRef()

const linkProps = useMemo(() => ({
  cursor: "pointer",
  className: classNames(className, { active }),
  component: "a",
  sx: {
    cursor: 'pointer',
    mb: 0,
    ...(variant === 'endMatter' && {
      '&&:hover': {
        fontWeight: 'bold',
      },
    }),
    ...sx,
  },
  target,
  variant,
  ...props
}), [active, className, sx, target, variant, props]);

	
  const OT = useCallback((e) => {
    if (window.OneTrust && typeof window.OneTrust.ToggleInfoDisplay === 'function') {
      window.OneTrust.ToggleInfoDisplay();
    } else {
      console.warn('OneTrust is not ready yet.');
    }
  }, [])
  
  const track = useCallback((e) => {
    //trackClick(urlJoin(!external && href.indexOf('http') < 0 ? document.location.origin : "", href), linkProps['data-tracking'], linkRef.current.innerText)
  }, [linkProps, external, href])

  const externalLinkHandler = useCallback((e) => {
    e.preventDefault();
    track();
    setExternalModalId(prompt);
    setExternalLink(href);
  }, [href, prompt, track])

  if (!href) return (
    <Typography
      component={component}
      className={classNames(className, { active })}
      sx={{ cursor: 'pointer', ...sx }}
      variant={variant}
      {...props}
    >
      {children}
    </Typography>
  )
  const Component = linkComponent;
  if (OneTrust)
	return <Component ref={linkRef} onClick={OT} target="_blank" {...linkProps} href="#">{children}</Component>
  if (external && !prompt)
    return <Component ref={linkRef} onClick={track} href={href} target="_blank" {...linkProps}>{children}</Component>
  if (prompt)
    return <Component ref={linkRef} onClick={externalLinkHandler} target="_blank" {...linkProps} href={href}>{children}</Component>

  const { className: linkClass, ...textProps } = linkProps;
  return (
    <NextLink href={href} target={target} prefetch={false} className={linkClass}>
      <Typography ref={linkRef} onClick={track} {...textProps} component={component}>{children}</Typography>
    </NextLink>
  )
}

export default Link